import { Link } from "react-router-dom";
import Badge from "../../../components/ui/Badge";
import { dtrLink, formatTotalHours, getCutoffStatus } from "../../dtr/dtrUtils";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Dashboard.module.css";

// The current cut-off: day counts, hours and its status (OPEN / APPROVED by
// HR / EXPORTED). There is nothing to submit.
const ThisPeriodCard = ({ cutoff }) => {
  const { period } = cutoff;
  const status = getCutoffStatus(cutoff.dtrStatus);
  const stats = [
    { label: "Present", value: cutoff.present },
    { label: "Late", value: cutoff.late },
    { label: "Absent", value: cutoff.absent },
    { label: "Half day", value: cutoff.halfDay },
    { label: "On leave", value: cutoff.onLeave },
  ];

  return (
    <>
      <div className={styles.stats}>
        {stats.map((stat) => (
          <div key={stat.label} className={styles.stat}>
            <div className={styles.statValue}>{stat.value}</div>
            <div className={styles.statLabel}>{stat.label}</div>
          </div>
        ))}
      </div>

      <div className={styles.rowBetween}>
        <span>
          <strong>{formatTotalHours(cutoff.totalWorkHours)}</strong> worked
          {cutoff.totalOvertimeHours > 0 && (
            <span className={ui.muted}>
              {" "}
              · {formatTotalHours(cutoff.totalOvertimeHours)} approved OT
            </span>
          )}
        </span>
        <span>
          <span className={ui.muted}>DTR: </span>
          <Badge tone={status.tone}>{status.label}</Badge>
        </span>
      </div>

      {cutoff.missingCheckOut?.length > 0 && (
        <p className="mt-2 mb-0 small text-danger">
          {cutoff.missingCheckOut.length} day(s) missing a check-out. Press Fix
          on the day in My DTR to ask for a correction.
        </p>
      )}

      {period && (
        <Link
          to={dtrLink(period)}
          className={`${ui.linkButton} d-inline-block mt-3`}
        >
          Open this cut-off's DTR <i className="bi bi-arrow-right"></i>
        </Link>
      )}
    </>
  );
};

export default ThisPeriodCard;
